import React from "react"
import { composeSx } from "../theme/composeSx"
import { Box, type BoxProps } from "@mui/material"
import { resolveViraPalette } from "../theme/resolveViraPalette"

export type DividerProps = BoxProps & {
  orientation?: "horizontal" | "vertical"
  inset?: boolean
}

export function Divider({
  orientation = "horizontal",
  inset = false,
  sx,
  ...rest
}: DividerProps) {
  const isHorizontal = orientation === "horizontal"
  return (
    <Box
      role="separator"
      aria-orientation={orientation}
      sx={composeSx(
        (theme) => ({
          flexShrink: 0,
          // vira.border / palette.divider is ~1.2:1 on paper — fine for card edges,
          // but a 1px hairline needs vira.subtle for readable contrast.
          bgcolor: resolveViraPalette(theme).subtle,
          ...(isHorizontal
            ? {
                height: "1px",
                // width:auto so inset mx shrinks the line instead of overflowing
                width: "auto",
                alignSelf: "stretch",
                mx: inset ? 3 : 0,
              }
            : {
                width: "1px",
                alignSelf: "stretch",
                height: "100%",
                minHeight: 24,
              }),
        }),
        sx,
      )}
      {...rest}
    />
  )
}
